<template>
  <!-- password change screen, link located on the login screen -->
  <div class="container-fluid py-5">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto">
        <div class="card card-signin my-5 card-opacity">
          <div class="card-body">
            <img
              class="mx-auto rounded mx-auto d-block logo-image"
              alt="logoImage"
              :src="logoImage"
            />
            <h5 class="card-title text-center text-join">Nova senha</h5>
            <form class="form-signin" autocomplete="off" @submit.prevent="accessPortal">
              <div style="display: flex; justify-content: center">
                <p class="text-align-center">
                  Insira abaixo sua nova senha e a confirmação
                </p>
              </div>
              <div class="form-label-group">
                <label for="newPassword label-config">Nova senha</label>

                <input
                  type="password"
                  id="newPasswordComponent"
                  class="form-control input-length"
                  placeholder=" Digite uma nova senha"
                  v-model="newPassword"
                  required
                  autocomplete="off"
                  autofocus
                />
              </div>
              <br />
              <div class="form-label-group">
                <label for="confirmNewPassword label-config">Repetir senha</label>

                <input
                  type="password"
                  id="confirmNewPasswordComponent"
                  class="form-control input-length"
                  placeholder="Repita sua nova senha"
                  v-model="newPasswordConfirmation"
                  required
                  autocomplete="off"
                  autofocus
                />

                <p class="text-password-align">
                  A senha deve conter no mínimo 8(oito) caracteres, contendo letras,
                  números e símbolos. O sistema diferencia letras maiúsculas de
                  minúsculas.
                </p>
              </div>
              <div class="access-center">
                <button class="btn btn-lg access-password" id="sendNewPasswordComponent" type="submit">
                  Fazer login
                </button>
                <br /><br />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "NewPassword",
  data() {
    return {
      logoImage: "",
      newPassword: "",
      newPasswordConfirmation: "",
      token: "",
      key: "",
      userId: "",
    };
  },
  mounted() {
    let group = localStorage.group;
    this.token = this.$route.query.token;
    this.key = this.$route.query.key;

    if (group) {
      axios.get(process.env.API_PBM + "/group/" + group).then((response) => {
        let background = response.data.data.background;
        let logo = response.data.data.logo;
        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        this.logoImage = logo != null ? logo : "";
      });
    }
    if (this.token && this.key) {
      axios
        .get(`${process.env.API_PBM}/user/password/info/${this.token}/${this.key}`)
        .then((response) => {
          this.userLogin = response.data.data.user_login;
          this.userId = response.data.data.user_id;
        });
    }
  },
  methods: {
    accessPortal: function () {
      let data = {
        token: this.token,
        key: this.key,
        new_password: this.newPassword,
        new_password_confirmation: this.newPasswordConfirmation,
      };
      axios
        .put(
          `${process.env.API_PBM}/user/password/reset/${this.userId}`,
          this.$qs.stringify(data)
        )
        .then((response) => {
          this.$router.push({ name: "ConfirmationPassword" });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: 40px;
}

.input-length {
  margin: 0 auto;
}

.input-user {
  background: transparent;
  border: none;
  border-bottom: 1px solid #000000;
  outline: none;
  box-shadow: none;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}

.text-align-center {
  margin-top: 5px;
  color: rgb(100, 95, 95);
  font-size: 13px;
}
.text-password-align {
  margin-top: 5px;
  color: grey;
  font-size: 14px;
}

.access-password {
  background-color: #b0191a;
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
}
.access-center {
  text-align: center;
}
@media only screen and (min-width: 1340px) {
  /* styles for browsers larger than 1440px; */
}
@media only screen and (min-width: 1440px) {
  .text-password-align {
    margin-top: 5px;
    margin-left: 48px !important;
    color: grey;
    font-size: 14px;
  }

  /* styles for browsers larger than 1440px; */
}

@media only screen and (max-width: 1940px) {
}

@media only screen and (min-width: 2000px) {
  /* for sumo sized (mac) screens */
}
</style>



// WEBPACK FOOTER //
// src/views/components/forgotPassword/NewPassword.vue